//Set cookies 
function getSec(str) {
  var str1 = str.substring(1, str.length) * 1;
  var str2 = str.substring(0, 1);
  if (str2 === "s") {
    return str1 * 1000;
  } else if (str2 === "h") {
    return str1 * 60 * 60 * 1000;
  } else if (str2 === "d") {
    return str1 * 24 * 60 * 60 * 1000;
  }
}

function setCookie(name, value, time) {
  var strsec = getSec(time);
  var exp = new Date();
  exp.setTime(exp.getTime() + strsec * 1);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
}


//Get cookies 
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (arr = document.cookie.match(reg))

    return unescape(arr[2]);
  else
    return null;
}

//Remove cookies 
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

export {
  setCookie,
  getCookie,
  delCookie
}